(function() {
	/**
	 * Renders appointment detail page: Appointment Item
	 * @param {Object} props - Page context and properties
	 * @returns {object} Promise
	 */
	WebBaseAprovLV.renderAppointmentPage = function(props) {
		var params = {
			page: props.context.params.page || '',
			detail: props.context.params.detail || ''
		};
		var model = {
			element: null,
			template: 'templates/appointment.ejs.html?v=' + WebBaseAprovLV.version.template,
			data: {
				main: (props.context.Model || {}).Main || {}, /* Comes from renderMainContent() */
				navRaw: null,
				pageRaw: null,
				appointmentRaw: null,
				nav: null,
				pageContent: null,
				appointment: null
			}
		};
		return $.when(
			// WebBaseAprovLV.Utils.getKKData('?system.type=page&system.codename[in]=news'),
			WebBaseAprovLV.Utils.getKKData('?system.type=page&elements.url[in]=' + params.page + '&depth=1'),
			WebBaseAprovLV.Utils.getKKData('?system.type=appointment_item&elements.url[in]=' + params.detail + '&depth=2'),
			ejs.preloadTemplate(model.template),
			ejs.preloadTemplate('templates/breadcrumb.ejs.html?v=' + WebBaseAprovLV.version.template),
			ejs.preloadTemplate('templates/bottomnav.ejs.html?v=' + WebBaseAprovLV.version.template)
		).then(function(pageXhr, appointmentXhr, tmplPage, tmplBreadcrumb, tmplBottomnav) {
			var pageRaw = Array.isArray(pageXhr) && pageXhr.length ? pageXhr[0] : (pageXhr || {});
			var appointmentRaw = Array.isArray(appointmentXhr) && appointmentXhr.length ? appointmentXhr[0] : (appointmentXhr || {});
			model.data.navRaw = {};
			model.data.pageRaw = pageRaw;
			model.data.appointmentRaw = appointmentRaw;
			model.element = $('#content');
			model.data = $.extend(model.data, {
				pageContent: WebBaseAprovLV.Utils.getKKViewModel(model.data.pageRaw)[0] || {},
				nav: WebBaseAprovLV.Utils.getKKViewModel(model.data.navRaw)[0] || {},
				appointment: WebBaseAprovLV.Utils.getKKViewModel(model.data.appointmentRaw)[0] || {}
			});
			return WebBaseAprovLV.Utils.transitionTo(model);
		}).promise();
	};
})();
